// extracted by mini-css-extract-plugin
module.exports = {"btnColor":"ColorButton_btnColor__1L3fP","selected":"ColorButton_selected__n5NS2","buttonWrapper":"ColorButton_buttonWrapper__22_46"};